import { styled } from '@streamelements/frontend-ui';
import { ComponentProps, forwardRef } from 'react';

export const Root = styled('svg', {
  fill: 'currentColor',
  width: '1em',
  height: '1em',
  display: 'inline-block',
  flexShrink: 0,
  userSelect: 'none',

  '&&': {
    fontSize: '$$size',
  },

  variants: {
    size: {
      '2xl': {
        $$size: '2rem',
      },
      xl: {
        $$size: '1.75rem',
      },
      lg: {
        $$size: '1.5rem',
      },
      default: {
        $$size: '1.5rem',
      },
      md: {
        $$size: '1.25rem',
      },
      sm: {
        $$size: '1.125rem',
      },
      xs: {
        $$size: '1rem',
      },
    },
  },

  defaultVariants: {
    size: 'sm',
  },
});

export function createIcon(functionName: string, children: React.ReactNode) {
  const result = forwardRef<SVGSVGElement, React.JSX.IntrinsicElements['svg'] & ComponentProps<typeof Root>>(
    function (props, ref) {
      return (
        <Root viewBox="0 0 24 24" {...props} ref={ref}>
          {children}
        </Root>
      );
    }
  );

  result.displayName = functionName;
  return result;
}
